import { useLayoutEffect, useState } from "react";

import type { ISwitcherConfig, ISwitcherConfigItem } from "app/components/React/WidgetContainer/types";
import { allTrackers } from "app/services/track/track";
import type { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

interface UseGranularitySwitcherParams {
    items: ISwitcherConfigItem[];
    defaultValue: GranularityNames;
    trackingName: string;
}

interface UseGranularitySwitcherResult {
    selectedGranularity: GranularityNames;
    setSelectedGranularity: (granularity: GranularityNames) => void;
    granularitySwitcherConfig: ISwitcherConfig[];
}

export const useGranularitySwitcher = ({
    items,
    defaultValue,
    trackingName,
}: UseGranularitySwitcherParams): UseGranularitySwitcherResult => {
    const [selectedGranularity, setSelectedGranularity] = useState<GranularityNames>(defaultValue);
    const selectedGranularityIndex = items.findIndex((item) => item.value === selectedGranularity);

    useLayoutEffect(() => {
        if (items[selectedGranularityIndex]?.disabled) {
            setSelectedGranularity(defaultValue);
        }
    }, [items[selectedGranularityIndex]?.disabled, defaultValue]);

    const handleGranularityChange = (index: number): void => {
        const granularity = items?.[index]?.value as GranularityNames;
        if (granularity) {
            setSelectedGranularity(granularity);
            allTrackers.dispatchTrackEvent("Time Frame Button", "switch", `${trackingName}/${granularity}`);
        }
    };

    const granularitySwitcherConfig: ISwitcherConfig[] = [
        {
            items,
            onItemClick: handleGranularityChange,
            initialSelectedItem: selectedGranularityIndex,
        },
    ];

    return {
        selectedGranularity,
        setSelectedGranularity,
        granularitySwitcherConfig,
    };
};
